import BundleHandler from './BundleHandler'

export default BundleHandler


// WEBPACK FOOTER //
// ./src/components/bundle/index.jsx